<script>
import CrmAccountsAccountPickups from '@/views/Application/CustomerService/Accounts/Account/Pickups'

export default {
  extends: CrmAccountsAccountPickups,
  data () {
    return {
      breadcrumb: {
        name: 'All Pickups',
        route: { name: 'sales-accounts-account-pickups', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
